import type { ComboInstrument } from "#/store/combo/comboInstruments";
import { isOptionInstrument } from "#/utils/instrument.utils";

export const updateLegRatios = (instruments: ComboInstrument[]) => {
  const smallestLegSize = Math.min(
    ...instruments
      .filter((leg) => isOptionInstrument(leg.type) && Number(leg.size) > 0)
      .map((leg) => Number(leg.size)),
  );

  return instruments.map((leg) => {
    const legSize = Number(leg.size);
    const legRatio = legSize > 0 ? legSize / smallestLegSize : NaN;

    return { ...leg, legRatio };
  });
};

export const sortLegsFn = (a: ComboInstrument, b: ComboInstrument) => {
  if (a.type === "perps") return 1;
  if (b.type === "perps") return -1;
  return 0;
};
